/* Demo-only cart mathematics. Deliberately no Shopify cart or checkout calls. */
(function (root) {
  'use strict';
  const quantity = value => Math.min(99, Math.max(1, Math.floor(Number(value) || 1)));
  function normalize(raw, catalog) {
    const combined = new Map();
    if (!Array.isArray(raw)) return [];
    for (const row of raw.slice(0, 200)) {
      if (!row || typeof row !== 'object') continue;
      const product = catalog.find(p => p.id === row.id);
      if (!product || !product.sizes.some(v => v.size === row.size)) continue;
      if (!Number.isFinite(Number(row.qty)) || Number(row.qty) <= 0) continue;
      const key = product.id + ':' + row.size;
      combined.set(key, { id: product.id, size: row.size, qty: quantity((combined.get(key)?.qty || 0) + Number(row.qty)) });
    }
    return [...combined.values()];
  }
  function totals(rows, catalog, delivery) {
    const items = normalize(rows, catalog);
    const subtotal = items.reduce((sum, row) => sum + catalog.find(p => p.id === row.id).price * row.qty, 0);
    const shipping = items.length && delivery === 'shipping' ? 590 : 0;
    const total = subtotal + shipping;
    return { subtotal, shipping, total, tax: total - Math.round(total / 1.19), count: items.reduce((sum, row) => sum + row.qty, 0) };
  }
  const api = { quantity, normalize, totals };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.FliegerCore = api;
})(typeof window !== 'undefined' ? window : globalThis);
